import styled from "styled-components";
import RecentAlertList from "../RecentAlertList";
import InfoListForManagement from "../sectionsForManagement/InfoListForManagement";
import CoworkerListForEmployee from "./CoworkerListForEmployee";
import MapSectionForEmployee from "./MapSectionForEmployee";
import ReviewListForEmployee from "./ReviewListForEmployee";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  width: 100%;
`;

export default function SectionsForEmployees() {
  return (
    <Container>
      <Section>
        <MapSectionForEmployee />
        <InfoListForManagement />
      </Section>

      <Section>
        <CoworkerListForEmployee />
        <RecentAlertList />
        <ReviewListForEmployee />
      </Section>
    </Container>
  );
}
